angular.module('impactx.productview').controller('ProductViewVCatsCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ProductViewService',
    'BackService',
    'ToolbarService',
    ProductViewVCatsCtrl
]);

function ProductViewVCatsCtrl($scope, dataGen, $routeParams, ProductViewService, BackService, ToolbarService) {
    var self = this;
    $scope.url = "vcatalog";

    dataGen.getData($scope, {id: $routeParams.id}, "/productview/list/vcats").then(function() {
        $scope.dynamicItems = new DynamicItems();
        defineButtons();
    });

    self.removeItem = function(vCat) {
        ProductViewService.removeVCatsFromProductView($routeParams.id, [vCat.id]).then(function() {
            $scope.data.relatedVCats.splice($scope.data.relatedVCats.indexOf(vCat), 1);
        });
    };

    self.removeAllItems = function() {
        var vCatIds = [];
        angular.forEach($scope.data.relatedVCats, function(vCat) {
            vCatIds.push(vCat.id);
        });

        return ProductViewService.removeVCatsFromProductView($routeParams.id, vCatIds).then(function() {
            BackService.back();
        });
    };

    var DynamicItems = function() {
    };

    DynamicItems.prototype.getItemAtIndex = function(index) {
        if($scope.data) {
            return $scope.data.relatedVCats[index]
        }
        else {
            return null;
        }
    };

    DynamicItems.prototype.getLength = function() {
        if($scope.data && $scope.data.relatedVCats) {
            return $scope.data.relatedVCats.length;
        }
        else {
            return 0;
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.removeAll,
                action: self.removeAllItems,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}